import React, { useEffect } from "react";
import { toast } from "sonner";
import { Moon } from "lucide-react";
import { useTheme } from "@/context/ThemeContext";

/**
 * ThemePrompt — shows a one-time Sonner toast on first visit asking if the
 * reader would prefer dark mode. Never nags again once dismissed or accepted.
 */
export default function ThemePrompt() {
  const { prompted, markPrompted, setTheme } = useTheme();

  useEffect(() => {
    if (prompted) return;
    const timer = setTimeout(() => {
      toast(
        <div className="flex items-start gap-3">
          <Moon className="w-5 h-5 text-terracotta mt-0.5 flex-shrink-0" strokeWidth={1.5} />
          <div className="text-sm">
            <div className="font-serif text-base text-ink">Prefer dark mode?</div>
            <div className="text-xs text-muted_ink mt-0.5">
              A quieter, charcoal reading room. You can flip back anytime.
            </div>
          </div>
        </div>,
        {
          duration: 15000,
          action: {
            label: "Switch",
            onClick: () => setTheme("dark"),
          },
          cancel: {
            label: "No thanks",
            onClick: () => {},
          },
        }
      );
      // Mark as shown immediately so we never nag the same visitor again,
      // regardless of what they click (or don't).
      markPrompted();
    }, 2000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prompted]);

  return null;
}
